import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

@Injectable({
  providedIn: 'root'
})
class AdminPermissionsService {
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    try {
      const person = JSON.parse(SessionHelper.getPerson());
      if (person && person.et_admin === true) {
        return true;
      }
    } catch (_error) {}

    this.router.navigate(['/dashboard']);
    return false;
  }
}

export const AdminGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AdminPermissionsService).canActivate(next, state);
};
